import Box from "@mui/material/Box";
import { lazy, Suspense } from "react";
import Stack from "@mui/material/Stack";
import MainCard from "../Layouts/MainCard";
import ExerciseEntity from "./ExerciseEntity";
import { Theme } from "../../data/style/Theme";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthContext";
import { getAthleteGymnastics } from "../../api/user";
import useScreenSize from "../../context/ScreenContext";
import TableChartIcon from "@mui/icons-material/TableChart";
import {
  MainTitle,
  scrollBar,
  SpacedRow,
  CenteredRow,
  MainText,
} from "../../data/style/Style";

const Loader = lazy(() => import("./Loader"));
const NoDataDiv = lazy(() => import("./NoDataDiv"));
const AbilitiesModal = lazy(() => import("../Modals/AblitiesModal"));

const Gymnastics = ({ showExerciseDetails }) => {
  const { user } = useAuth();
  const { mobileDevice } = useScreenSize();

  const { data, isPending } = useQuery({
    queryKey: ["abilities", "gymnastics", user.id],
    queryFn: ({ signal }) => getAthleteGymnastics({ signal }),
    staleTime: 30 * 60 * 1000,
  });

  return (
    <Box flex={1} minWidth={"270px"}>
      <MainCard start={Theme.palette.bronze} middle={Theme.palette.bronze}>
        {!isPending ? (
          <>
            <SpacedRow alignItems={"center"}>
              <CenteredRow gap={1}>
                <MainText fontSize={"1.2rem"}>🤸</MainText>
                <MainTitle>Gymnastics</MainTitle>
              </CenteredRow>
              <Suspense>
                <AbilitiesModal
                  type={"gymnastics"}
                  color={Theme.palette.bronze}
                />
              </Suspense>
            </SpacedRow>
            {data.length > 0 ? (
              <Stack p={0.5} height={"30vh"} sx={scrollBar} overflow={"auto"}>
                {data.map((item) => (
                  <ExerciseEntity
                    key={item.id}
                    item={item}
                    showExerciseDetails={showExerciseDetails}
                    type={"gymnastics"}
                  />
                ))}
              </Stack>
            ) : (
              <Suspense>
                <NoDataDiv
                  height={"30vh"}
                  minHeight={"160px"}
                  icon={
                    <TableChartIcon
                      sx={{
                        fontSize: mobileDevice ? "3rem" : "4rem",
                        color: Theme.palette.bronze,
                      }}
                    />
                  }
                  text={"No data available. Start tracking your progress."}
                />
              </Suspense>
            )}
          </>
        ) : (
          <Suspense>
            <Loader height={"35vh"} minHeight={"100px"} />
          </Suspense>
        )}
      </MainCard>
    </Box>
  );
};

export default Gymnastics;
